export default __webpack_public_path__ + "static/media/compound-logo.19bd5751.svg";